import { gql } from '@apollo/client';

export const GET_FUNERAL_SERVICE_BY_ID = gql`
  query GetFuneralServiceById($id: ID!) {
    defunto(id: $id) {
      objectId
      nome
      cognome
      sesso
      data_morte
      cimitero
      forno
      createdAt
    }
  }
`;

export const COUNT_FUNERAL_SERVICES = gql`
  query CountFuneralServices {
    defuntos {
      count
    }
  }
`;

export const FIND_FUNERAL_SERVICES = gql`
  query FindFuneralServices(
    $limit: Int!
    $after: String
    $where: DefuntoWhereInput!
  ) {
    defuntos(
      first: $limit
      order: data_morte_DESC
      where: $where
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      count
      edges {
        node {
          id
          cimitero
          forno
          objectId
          nome
          cognome
          data_morte
          sesso
          createdAt
        }
      }
    }
  }
`;
